<div class="row nav-container">
  <div class="row button-container">
    <span class="nav-previous clickable">
      @if (rubixDocumentsService.previousFolderDetails?.length) {
      <img
        (click)="onClickToPrevious()"
        class="previous-active icon clickable"
        src="assets/rubix-documents/keyboard_double_arrow_left_black_24dp.svg"
        alt="double_left"
      />
      } @if (rubixDocumentsService.previousFolderDetails?.length===0) {
      <img
        class="previous-inactive icon"
        src="assets/rubix-documents/keyboard_double_arrow_left_black_24dp.svg"
        alt="double_left"
      />
      }
    </span>

    <span class="nav-next">
      @if (rubixDocumentsService.nextFolderDetails?.length) {
      <img
        (click)="onClickToNext()"
        class="previous-active icon clickable"
        src="assets/rubix-documents/keyboard_double_arrow_right_black_24dp.svg"
        alt="double_right"
      />
      } @if (rubixDocumentsService.nextFolderDetails?.length===0) {
      <img
        class="previous-inactive icon"
        src="assets/rubix-documents/keyboard_double_arrow_right_black_24dp.svg"
        alt="double_right"
      />
      }
    </span>
  </div>

  @if (currentFolderPathList?.length < 4) {
  <div class="row path-container">
    @for (folderNode of currentFolderPathList; track folderNode.id; let i = $index)
    {
    <span class="row">
      @if (i!==currentFolderPathList?.length-1) {
      <span class="row">
        <span class="clickable" (click)="onClickFolderName(i)">{{
          folderNode.name
        }}</span>
        <span>
          <img
            class="right-icon icon"
            src="assets/rubix-documents/keyboard_arrow_right_black_24dp.svg"
            alt="arrow_right"
          />
        </span>
      </span>
      } @if (i===currentFolderPathList?.length-1) {
      <span class="row">
        <span class="folder-current">{{ folderNode.name }}</span>
      </span>
      }
    </span>
    }
  </div>
  } @if (currentFolderPathList?.length >= 4) {
  <div class="row path-container">
    @for (folderNode of currentFolderPathList; track folderNode.id; let i = $index)
    {
    <span class="row">
      @if (i===1) {
      <span class="row">
        <span class="clickable" (click)="onClickFolderName(i)">{{
          folderNode.name
        }}</span>
        <span>
          <img
            class="right-icon icon"
            src="assets/rubix-documents/keyboard_arrow_right_black_24dp.svg"
            alt="arrow_right"
          />
        </span>
        <span>...</span>
        <span>
          <img
            class="right-icon icon"
            src="assets/rubix-documents/keyboard_arrow_right_black_24dp.svg"
            alt="arrow_right"
          />
        </span>
      </span>
      } @if (i===currentFolderPathList?.length-2) {
      <span class="row">
        <span class="clickable" (click)="onClickFolderName(i)">{{
          folderNode.name
        }}</span>
        <span>
          <img
            class="right-icon icon"
            src="assets/rubix-documents/keyboard_arrow_right_black_24dp.svg"
            alt="arrow_right"
          />
        </span>
      </span>
      } @if (i===currentFolderPathList?.length-1) {
      <span class="row">
        <span class="folder-current">{{ folderNode.name }}</span>
      </span>
      }
    </span>
    }
  </div>
  }
</div>
